import { Component, inject, input, model, output } from '@angular/core';
import { ServiciosService } from '../services/servicios.service';
import { RoutesService } from '../../shared/services/routes.service';
import { AccessService } from '../../core/services/access.service';
import { ServiciosInterface } from '../interfaces/servicio.interface';
import { ResourceFormCardComponent } from "../../shared/components/resource-form-card/resource-form-card.component";
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ResourceButtonGroupComponent } from "../../shared/components/resource-button-group/resource-button-group.component";
import { Servicio, Servicios } from '../models/servicio.model';

@Component({
  selector: 'app-servicios-list',
  standalone: true,
  imports: [
    ResourceFormCardComponent,
    CommonModule,
    TableModule,
    ResourceButtonGroupComponent
],
  templateUrl: './servicios-list.component.html',
  styleUrl: './servicios-list.component.css'
})
export class ServiciosListComponent {
  protected service = inject(ServiciosService)
  protected routesService = inject(RoutesService)

  protected access = inject(AccessService).access
  protected resource = this.service.resource?.toLowerCase();

  public detailed = input<boolean>(true);

  protected value = this.service.servicios

  public length = output<number>()

  ngOnInit(): void {
    // console.log('OnInit called of ListBranchComponent.')
    this.service.title.update((value) => 'Lista de Servicios')
    this.service.get().subscribe(data => {
      // data = (data as ServiciosInterface).map((value) => new Servicio(value))
      this.value.update(value => {
        value = (data as ServiciosInterface).map((value) => new Servicio(value))
        // console.log('Branch List: ', value)
        // console.log('value ad List: ', value.length)
        this.length.emit(value.length)
        return value
      })
    })
  }
}


